import React from 'react';
import 'pdfjs-dist/build/pdf';
import 'pdfjs-dist/web/pdf_viewer';
import 'pdfjs-dist/web/compatibility';

import 'pdfjs-dist/web/pdf_viewer.css';

import pdfWorker from 'entry-loader?name=pdf-worker-[hash].js!pdfjs-dist/build/pdf.worker.entry';

window.PDFJS.workerSrc = pdfWorker;

const DEFAULT_SCALE_VALUE = 'page-fit';

class Pdf extends React.Component {

  static propTypes = {
    src: React.PropTypes.string.isRequired,
  };

  componentDidMount() {
    const { src } = this.props;
    this.loadPdf(src);
    window.addEventListener('resize', this.onResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize, false);
  }

  onResize = () => {
    if (this.pdfViewer) {
      clearTimeout(this.throttleResizeTimer);
      this.throttleResizeTimer = setTimeout(() => {
        this.pdfViewer.currentScaleValue = DEFAULT_SCALE_VALUE;
      }, 500);
    }
  };

  documentPromise = null;
  document = null;
  pdfViewer = null;
  linkService = null;

  initPdvViewer = (container) => {
    if (container) {
      this.linkService = new window.PDFJS.PDFLinkService();
      this.pdfViewer = new window.PDFJS.PDFViewer({
        container,
        linkService: this.linkService,
      });
      container.addEventListener('pagesinit', () => {
        // We can use pdfViewer now, e.g. let's change default scale.
        this.pdfViewer.currentScaleValue = DEFAULT_SCALE_VALUE;
      });

      this.linkService.setViewer(this.pdfViewer);
    }
  };

  documentLoadSuccess = (document) => {
    this.document = document;
    this.pdfViewer.setDocument(document);
    this.linkService.setDocument(document);
  };

  documentLoadError = (err) => {
    console.error('Document load error', err);
  };

  loadPdf = (url) => {
    if (this.documentPromise) {
      this.documentPromise.cancel();
    }
    this.documentPromise = window.PDFJS.getDocument(url).promise;
    this.documentPromise
      .then(this.documentLoadSuccess)
      .catch(this.documentLoadError);
    return this.documentPromise;
  };

  render() {
    const {
      src, // eslint-disable-line no-unused-vars
      ...other
    } = this.props;
    return (
      <div ref={this.initPdvViewer} {...other}>
        <div className="pdfViewer"/>
      </div>
    );
  }
}

export default Pdf;



// WEBPACK FOOTER //
// ./book/src/pdfjs/Pdf.jsx